/*
 * This file contains the floorplan grid component.
 */

import styles from "../floorplans.module.scss";
import FloorplanGridCard from "./floorplanGridCard";
import Pagination from "../../Pagination/pagination";
import { formatResultCount, getBreadcrumbUrl } from "../../../utils/util";
import FloorplanSkelton from "./floorplanSkelton/floorplanSkelton";
import CommunityCostGuide from "./communityCostGuide";

export default function FloorplanGrid({
  data,
  typeListing,
  page,
  setPage,
  loading,
  contactLink,
  params,
  moveInStartDate,
  setIsUserInteraction,
  setIsPaginationInteraction,
}) {
  let dataToDisplay = data?.fp || [];

  // This function handles the page change event.
  // It updates the page state with the new page number.
  const handlePageChange = (page) => {
    setIsPaginationInteraction(true);
    setPage(parseInt(page));
    setIsUserInteraction(true);
  };

  // This conditional sets the dataToDisplay to the units of the first floorplan if typeListing is false and there are floorplans available.
  if (!typeListing && data?.fp?.length > 0) {
    dataToDisplay = data?.fp[0]?.units || [];
  }

  // This conditional renders a skeleton loader if the loading state is true.
  if (loading) {
    return (
      <div className={styles.FloorplanGrid}>
        <FloorplanSkelton activeTab="grid" />
      </div>
    );
  }

  // This conditional renders an error message if there are no results.
  // Only show when data exists and total is less than 1 (not when data is null/undefined during navigation)
  if (data && data.total < 1) {
    return (
      <div className={styles.FloorplanGrid}>
        <div className={styles.errorContainer}>
          <div>
            <h3>No results found</h3>
            <p>
              {data?.config?.no_result_message?.split("contact [url]")[0]}
              <a href={data?.config?.contact_page_url}>contact</a>
              {data?.config?.no_result_message?.split("contact [url]")[1]}
            </p>
          </div>
        </div>
        <CommunityCostGuide />
      </div>
    );
  }

  // Show skeleton if data is not yet loaded (during navigation)
  if (!data) {
    return (
      <div className={styles.FloorplanGrid}>
        <FloorplanSkelton activeTab="grid" />
      </div>
    );
  }

  // This conditional renders the floorplan grid if there are results.
  return (
    <div className={styles.FloorplanGrid}>
      {!typeListing && dataToDisplay?.length > 0 && (
        <>
          <p className={styles.InnerNav}>
          <a href={getBreadcrumbUrl(params)}>Floor Plan</a>&nbsp;/&nbsp;
            <a href={`/floor-plans/${data?.fp[0]?.floorplan_id}`}>
              {dataToDisplay[0]?.floorplan_name}
            </a>
          </p>
          <p className={styles.FloorplanName}>
            {dataToDisplay[0]?.floorplan_name}
          </p>
        </>
      )}


      {data?.total > 0 ? (
        <>
          <p className={styles.ResultsCount}>
            Showing {formatResultCount(data?.total)} results
          </p>
          <div className={styles.FloorplanGridContainer}>
            {dataToDisplay?.map((item, index) => (
              <FloorplanGridCard
                typeListing={typeListing}
                key={`${item?.id}${index}`}
                data={item}
                fpData={typeListing ? data?.fp[index] : data?.fp[0]}
                specials={data?.specials}
                contactLink={contactLink}
                params={params}
                moveInStartDate={moveInStartDate}
                engrainFeeCalculator={data?.engrain_fee_calculator}
              />
            ))}
          </div>
        </>
      ) : (
        <div className={styles.FloorplanGrid}>
          <div className={styles.errorContainer}>
            <div>
              <h3>No results found</h3>
              <p>
                {data?.config?.no_result_message?.split("contact [url]")[0]}
                <a href={data?.config?.contact_page_url}>contact</a>
                {data?.config?.no_result_message?.split("contact [url]")[1]}
              </p>
            </div>
          </div>
        </div>
      )}
      {/* <div className={styles.footerDisclaimer}>
        Floor plans are artist’s rendering. All dimensions are approximate.
        Actual product and specifications may vary in dimension or detail. Not
        all features are available in every apartment. Prices and availability
        are subject to change and may not be reflective of the selected move-in
        date. For questions, please contact our leasing team.
      </div> */}
      {data?.total > 0 && (
        <Pagination
          currentPage={page}
          totalPages={Math.ceil(data?.total / data?.perpage)}
          onPageChange={handlePageChange}
        />
      )}
      
      
      <CommunityCostGuide data={data} />
    </div>
  );
}
